import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ApiService } from '../../services/api.service';
import * as _ from 'lodash';
import {CALENDAR_LOCALE, DOC_TEMPLATES} from '../../services/constant';
import * as moment from 'moment';
import {HttpParams} from '@angular/common/http';
import { TemplateService } from '../../services/template.service';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-tax-b2p',
  templateUrl: './tax-b2p.component.html',
  styleUrls: ['./tax-b2p.component.scss'],
  providers: [TemplateService]
})
export class TaxB2PComponent implements OnInit {
  itemsPerPage = 40;
  detailItemsPerPage = 40;

  currentPage = 1;
  totalItems: number;
  detailCurrentPage = 1;
  detailTotalItems: number;
  loading = false;

  sortBy: string;
  sortMode: string;
  detailSortBy: string;
  detailSortMode: string;

  tableData: Array<any>;
  tableColumn = [];
  detailTableData: object[];
  detailTableColumn = [];

  minDate: Date;
  maxDate: Date;
  error: string;
  viewing: any;

  company: object[];
  supplier: object[];
  documentType = [];
  status = [];
  calendarLocale;

  selectedBuyer: number = null;
  selectedCompany: number = null;
  startDate: Date;
  endDate: Date;
  selectedDocumentType: object = null;
  selectedStatus: string = null;
  selectedDetailDocumentType: object = null;
  selectedDetailStatus: string = null;

  @ViewChild('tt') table: any;
  @ViewChild('ttd') detailTable: any;

  constructor(private apiService: ApiService,
              private template: TemplateService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.loadTexts();
    this.loadData();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadTexts();
      this.loadData();
    });
  }

  loadTexts() {
    if (this.translate.currentLang === 'en') {
      this.calendarLocale = CALENDAR_LOCALE.EN;
    } else {
      this.calendarLocale = CALENDAR_LOCALE.TH;
    }

    this.detailTableColumn = [];
    this.tableColumn = [];
    this.status = [];
    this.translate.get('COMMON.ALL').subscribe((res: string) => {
      this.populateDropdown();
      this.status.push(
        { label: this.translate.instant('COMMON.ALL'), value: null },
        { label: this.translate.instant('TAX-B2P.ONLY-SUCCESSFUL'), value: 'success_only' },
        { label: this.translate.instant('TAX-B2P.ONLY-FAILED'), value: 'failed_only' }
      );
      this.tableColumn.push(
        { field: 'date', header: 'Batch Date' },
        { field: 'buyer', header: this.translate.instant('TAX-B2P.TABLE.BUYER') },
        { field: 'seller', header: this.translate.instant('TAX-B2P.TABLE.SELLER') },
        { field: 'doc_count_success', header: this.translate.instant('TAX-B2P.TABLE.SUCCESSFUL-DOCS') },
        { field: 'doc_count_fail', header: this.translate.instant('TAX-B2P.TABLE.FAILED-DOCS') },
        { field: 'doc_count_all', header: this.translate.instant('TAX-B2P.TABLE.ALL-DOCS') },
      );
      this.detailTableColumn.push(
        { field: 'branch', header: this.translate.instant('FILTER.BRANCH') },
        { field: 'header_issue_date', header: this.translate.instant('FILTER.DATE-OF-ISSUE') },
        { field: 'invoice_number', header: this.translate.instant('TAX-B2P.TABLE.INVOICE-NUMBER') },
        { field: 'doc_type', header: this.translate.instant('COMMON.CATEGORY') },
        { field: 'message', header: this.translate.instant('TAX-B2P.TABLE.MESSAGE') },
        { field: 'status', header: this.translate.instant('TAX-B2P.STATUS') }
      );
      const documentData = this.template.getDropdown();
      documentData[0] = {label: this.translate.instant('COMMON.ALL'), value: null};
      this.documentType = documentData;
    });
  }

  get yearRange() {
    const thisYear = (new Date()).getFullYear();
    return (thisYear - 40) + ':' + thisYear;
  }

  get dateRange() {
    const start = moment(this.startDate).format('DD/MM/YYYY');
    const end = moment(this.endDate).format('DD/MM/YYYY');
    return start + ' - ' + end;
  }

  get viewingDateDisplay() {
    if (this.viewing == null) {
      return null;
    }
    const date = parseInt(this.viewing.doc_date.substr(8, 2), 10);
    const month = this.calendarLocale.monthNames[parseInt(this.viewing.doc_date.substr(5, 2), 10) - 1];
    const year = parseInt(this.viewing.doc_date.substr(0, 4), 10) + 543;
    return date + ' ' + month + ' ' + year;
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  populateDropdown() {
    // populate company_groups list
    this.company = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    this.apiService.getCompany().subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.company.push({
            label: obj.name,
            value: obj.id
          });
        });
      }
    );

    // populate supplier list
    this.supplier = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    this.apiService.getBuyer({include_in_b2p: 'True'}).subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.supplier.push({
            label: obj.name,
            value: obj.id
          });
        });
      }
    );

    // populate document type
    this.documentType = this.template.getDropdown();

    // set default date range
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
  }

  loadData(params?) {
    this.loading = true;

    const data = {
      company: this.selectedCompany,
      buyer: this.selectedBuyer,
      doc_type: this.selectedDocumentType,
      start_date: moment(this.startDate).format('YYYY-MM-DD'),
      end_date: moment(this.endDate).format('YYYY-MM-DD'),
      status: this.selectedStatus,
      items_per_page: this.itemsPerPage
    };

    // apply sort if any
    if (this.sortBy != null && this.sortMode != null) {
      data['sort'] = this.sortBy;
      data['sort_type'] = this.sortMode;
    }

    // remove page number if current page is 1
    if (this.currentPage === 1) {
      params = null;
    }

    this.apiService.postB2PDocumentSummary(data, params).subscribe(
      result => {
        this.totalItems = result.count;
        this.tableData = result.results.map(obj => ({
          ...obj,
          loadingExcel: false
        }));
        this.loading = false;
      },
      error => {
        this.error = this.translate.instant('TAX-B2P.ERROR');
        this.loading = false;
      }
    );
  }

  search() {
    // check number of days > 60?
    if (moment(this.endDate).diff(moment(this.startDate), 'days') > 60) {
      this.error = this.translate.instant('FILTER.ERROR.DIFF');
      return;
    }
    this.error = null;

    // separate page
    if (this.viewing == null) {  // summary page
      this.currentPage = 1;
      this.sortBy = null;
      this.sortMode = null;
      if (this.tableData && this.tableData.length > 0) {
        this.table.reset();
      }
      this.loadData();
    } else {  // detail page
      this.detailCurrentPage = 1;
      this.detailSortBy = null;
      this.detailSortMode = null;
      if (this.detailTableData && this.detailTableData.length > 0) {
        this.detailTable.reset();
      }
      this.loadDetailData();
    }
  }

  detailPageChanged() {
    const params = new HttpParams().set('page', _.toString(this.detailCurrentPage));
    this.loadDetailData(params);
  }

  detailSort(event) {
    this.detailSortBy = event.field;
    if (event.order === 1) {
      this.detailSortMode = 'asc';
    } else {
      this.detailSortMode = 'desc';
    }
  }

  loadDetailData(params?) {
    this.loading = true;

    const data = {
      ...this.viewing,
      doc_type: this.selectedDetailDocumentType,
      status: this.selectedDetailStatus,
      items_per_page: this.detailItemsPerPage
    };

    // apply sort if any
    if (this.detailSortBy != null && this.detailSortMode != null) {
      data['sort'] = this.detailSortBy;
      data['sort_type'] = this.detailSortMode;
    }

    // remove page number if current page is 1
    if (this.detailCurrentPage === 1) {
      params = null;
    }

    this.apiService.postB2PDocumentSummaryDetail(data, params).subscribe(
      result => {
        this.detailTotalItems = result.count;
        this.detailTableData = result.results;
        this.loading = false;
      },
      error => {
        this.error = this.translate.instant('TAX-B2P.ERROR');
        this.loading = false;
      }
    );
  }

  clear() {
    // separate page
    if (this.viewing == null) {  // summary page
      this.selectedCompany = null;
      this.selectedBuyer = null;

      // set default date range
      this.startDate = new Date();
      this.startDate.setDate(this.startDate.getDate() - 60);
      this.endDate = new Date();

      this.selectedDocumentType = null;
      this.selectedStatus = null;
    } else {  // detail page
      this.selectedDetailDocumentType = null;
      this.selectedDetailStatus = null;
    }

    // reload data
    this.search();
  }

  pageChanged() {
    const params = new HttpParams().set('page', _.toString(this.currentPage));
    this.loadData(params);
  }

  sort(event) {
    this.sortBy = event.field;
    if (event.order === 1) {
      this.sortMode = 'asc';
    } else {
      this.sortMode = 'desc';
    }
  }

  downloadExcel(index) {
    this.tableData[index].loadingExcel = true;

    const data = {
      ...this.tableData[index],
      doc_type: this.selectedDocumentType,
      status: this.selectedStatus
    };

    this.apiService.downloadB2PDocumentSummaryDetailExcel(data).subscribe(
      obj => {
        const file_name = 'documents' + moment().format('YYYY-MM-DD') + '.xlsx';
        this.apiService.createDownloadFile(obj, file_name);
        this.tableData[index].loadingExcel = false;
      },
      error => {
      }
    );
  }

  setMinDate() {
    this.minDate = this.startDate;
    if (this.endDate < this.minDate) {
      this.endDate = this.minDate;
    }
  }

  setMaxDate() {
    this.maxDate = this.endDate;
    if (this.startDate > this.maxDate) {
      this.startDate = this.maxDate;
    }
  }

  viewDetail(event) {
    // this.detailItemsPerPage = 40;
    // this.detailCurrentPage = 1;
    // this.detailSortBy = null;
    // this.detailSortMode = null;
    // this.detailTableData = [];
    // this.detailTotalItems = undefined;
    this.selectedDetailDocumentType = this.selectedDocumentType;
    this.selectedDetailStatus = this.selectedStatus;
    this.loadDetailData();
  }

  viewSummary() {
    // this.detailItemsPerPage = 40;
    this.detailCurrentPage = 1;
    this.detailSortBy = null;
    this.detailSortMode = null;
    this.detailTableData = [];
    this.detailTotalItems = undefined;
    // this.selectedDetailDocumentType = null;
    // this.selectedDetailStatus = null;

    this.viewing = null;
  }
}




// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-b2p/tax-b2p.component.ts